export const BASE_ASIDE_MODEL = {
  login: {
    description: 'auth.loginAside.description',
  },
  registration: {
    description: 'auth.registered.default.description',
    baseClass: 'auth-register-page',
  },
  emasters: {
    description: 'auth.loginAside.description',
    baseClass: 'emasters',
  },
};
